// Page transition
window.addEventListener("beforeunload", () => {
    document.body.classList.add("unloading");
});

// window.addEventListener("load", () => {
//     document.body.classList.add("loaded");
//     document.dispatchEvent(new CustomEvent("page:loaded"));
// });

window.addEventListener("DOMContentLoaded", () => {
    document.body.classList.add("loaded");
    document.dispatchEvent(new CustomEvent("page:loaded"));
});

window.addEventListener("pageshow", (event) => {
    if (event.persisted) document.body.classList.remove("unloading");
});
